import {
  Drawer,
  DrawerContent,
  DrawerTrigger,
  DrawerClose,
} from "@/components/ui/drawer";
import { useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { HugeiconsIcon } from "@hugeicons/react";
import { defaultNavigationLinks } from "./nav-links";

const MenuDrawer = ({ children }: React.PropsWithChildren) => {
  const location = useLocation();
  const currentPath = "" + location.pathname;

  return (
    <Drawer>
      <DrawerTrigger asChild>{children}</DrawerTrigger>
      <DrawerContent>
        <div className="px-2 pb-4 space-y-0.5 mt-2">
          {defaultNavigationLinks.map((link) => {
            const isActive = currentPath.startsWith(link.href);
            return (
              <DrawerClose key={link.href} asChild>
                <a
                  href={link.href}
                  aria-current={isActive ? "page" : undefined}
                  className={cn(
                    "flex items-center gap-3 rounded-md px-3 py-2.5 text-sm font-medium transition-colors cursor-pointer no-underline",
                    isActive
                      ? "bg-[var(--flozy-blue-50)] text-primary"
                      : "text-foreground hover:bg-muted",
                  )}
                >
                  <HugeiconsIcon
                    icon={link.icon}
                    size={20}
                    strokeWidth={1.75}
                    className={
                      isActive ? "text-primary" : "text-muted-foreground"
                    }
                  />
                  {link.label}
                </a>
              </DrawerClose>
            );
          })}
        </div>
      </DrawerContent>
    </Drawer>
  );
};

export { MenuDrawer };
